var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticStyle: { height: "30px", "border-bottom": "1px solid #ddd" } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$route.query.id ? "修改" : "新建") +
                "计划外代采单\n    "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { height: "50px" },
          attrs: { type: "flex", justify: "center" }
        },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  staticStyle: { width: "1200px !important" },
                  attrs: { inline: true, model: _vm.form }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商家" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "remote-method": _vm.fetchSupply,
                            remote: "",
                            filterable: ""
                          },
                          model: {
                            value: _vm.supply_id,
                            callback: function($$v) {
                              _vm.supply_id = $$v
                            },
                            expression: "supply_id"
                          }
                        },
                        _vm._l(_vm.supplyOption, function(item) {
                          return _c("el-option", {
                            key: item.supply_id,
                            attrs: {
                              value: item.supply_id,
                              label: item.supply_name
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { label: "支付情况", placeholder: "选择支付情况" },
                      model: {
                        value: _vm.form.cg_type,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cg_type", $$v)
                        },
                        expression: "form.cg_type"
                      }
                    },
                    _vm._l(_vm.cgtypeOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { value: item.value, label: item.label }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticStyle: { width: "150px" },
                        attrs: { placeholder: "垫付人" },
                        model: {
                          value: _vm.form.prepay_people,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form,
                              "prepay_people",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.prepay_people"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { height: "150px" } },
        [
          _c(
            "el-row",
            {
              staticStyle: { height: "60px" },
              attrs: { type: "flex", justify: "center" }
            },
            [
              _c(
                "el-col",
                { style: "width:100%;", attrs: { span: 24 } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      staticStyle: {
                        display: "inline-block",
                        "margin-right": "10px"
                      },
                      style: "width:100px;float:left;height:50px;",
                      attrs: {
                        "show-file-list": false,
                        action: _vm.action,
                        multiple: "",
                        accept: "image/*",
                        "on-success": _vm.uploadSuccess1,
                        "on-remove": _vm.handleRemove,
                        "before-upload": _vm.beforeAvatarUpload,
                        limit: 9,
                        "on-exceed": _vm.handleExceed,
                        "file-list": _vm.files,
                        "with-credentials": ""
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { margin: "10px 3px" },
                          attrs: { size: "small", type: "primary" }
                        },
                        [_vm._v("\n            上传开单单据")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.images1.length > 0
                    ? _vm._l(_vm.images1, function(item) {
                        return _c(
                          "div",
                          {
                            key: item,
                            staticStyle: {
                              float: "left",
                              width: "50px",
                              height: "50px",
                              margin: "0 10px",
                              border: "1px solid #ddd"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px"
                                  },
                                  attrs: { src: item },
                                  on: {
                                    click: function($event) {
                                      return _vm.previewImage(item)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "15px",
                                      height: "15px",
                                      position: "absolute",
                                      top: "-5px",
                                      right: "-5px"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteImg1(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "15px",
                                        height: "15px"
                                      },
                                      attrs: {
                                        src:
                                          _vm.origin +
                                          "/201804/13/15235857625ad012e238658.png"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-dialog",
                {
                  attrs: { visible: _vm.dialogVisible },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogVisible = $event
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              staticStyle: { height: "60px" },
              attrs: { type: "flex", justify: "center" }
            },
            [
              _c(
                "el-col",
                { style: "width:100%;", attrs: { span: 24 } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      staticStyle: {
                        display: "inline-block",
                        "margin-right": "10px"
                      },
                      style: "width:100px;float:left;",
                      attrs: {
                        "show-file-list": false,
                        action: _vm.action,
                        multiple: "",
                        accept: "image/*",
                        "on-success": _vm.uploadSuccess2,
                        "on-remove": _vm.handleRemove,
                        "before-upload": _vm.beforeAvatarUpload,
                        limit: 9,
                        "on-exceed": _vm.handleExceed,
                        "file-list": _vm.files,
                        "with-credentials": ""
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { margin: "10px 3px" },
                          attrs: { size: "small", type: "primary" }
                        },
                        [_vm._v("\n            上传付款回执")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.images2.length > 0
                    ? _vm._l(_vm.images2, function(item) {
                        return _c(
                          "div",
                          {
                            key: item,
                            staticStyle: {
                              float: "left",
                              width: "50px",
                              height: "50px",
                              margin: "0 10px",
                              border: "1px solid #ddd"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { position: "relative" } },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px"
                                  },
                                  attrs: { src: item },
                                  on: {
                                    click: function($event) {
                                      return _vm.previewImage(item)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "15px",
                                      height: "15px",
                                      position: "absolute",
                                      top: "-5px",
                                      right: "-5px"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteImg2(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "15px",
                                        height: "15px"
                                      },
                                      attrs: {
                                        src:
                                          _vm.origin +
                                          "/201804/13/15235857625ad012e238658.png"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "padding-bottom": "auto" } },
        [
          _c(
            "el-row",
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "card-title",
                    staticStyle: {
                      height: "40px",
                      "padding-left": "15px",
                      "padding-top": "10px"
                    }
                  },
                  [
                    _vm._v("\n          商品信息\n          "),
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          "margin-left": "94%",
                          position: "relative",
                          top: "-30px"
                        },
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.selectGoods }
                      },
                      [_vm._v("选择商品")]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { staticStyle: { border: "1px solid #ddd" } },
                [
                  _vm.goodsList
                    ? _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          attrs: {
                            height: "700",
                            "tooltip-effect": "dark",
                            data: _vm.goodsList
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "序号",
                              type: "index",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "goods_img",
                              label: "商品图片"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", [
                                        _c("img", {
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px"
                                          },
                                          attrs: { src: scope.row.goods_img },
                                          on: {
                                            click: function($event) {
                                              return _vm.previewImage(
                                                scope.row.goods_img
                                              )
                                            }
                                          }
                                        })
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              43512192
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "goods_name",
                              label: "商品名称"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "goods_no",
                              label: "货号"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "brand_name",
                              label: "品牌"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "pg_name",
                              label: "买手组"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "颜色" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        [
                                          scope.row.colval_ary.length > 0
                                            ? _c(
                                                "el-select",
                                                {
                                                  attrs: {
                                                    label: "颜色",
                                                    placeholder: "颜色"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.getSizeArr(
                                                        scope.row
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: scope.row.co_val,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "co_val",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.co_val"
                                                  }
                                                },
                                                _vm._l(
                                                  scope.row.colval_ary,
                                                  function(item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.key
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2094375206
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "尺码" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return scope.row
                                      ? [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: {
                                                    label: "尺码",
                                                    placeholder: "尺码"
                                                  },
                                                  model: {
                                                    value: scope.row.si_val,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        scope.row,
                                                        "si_val",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "scope.row.si_val"
                                                  }
                                                },
                                                _vm._l(
                                                  scope.row.sizeval_ary,
                                                  function(item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label: item,
                                                        value: item
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      : undefined
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "数量" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return scope.row
                                      ? [
                                          _c(
                                            "div",
                                            [
                                              _c("el-input-number", {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  size: "small",
                                                  min: 1,
                                                  max: 10000,
                                                  label: "数量"
                                                },
                                                model: {
                                                  value: scope.row.num,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "num",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "scope.row.num"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      : undefined
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "price",
                              label: "代采价",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: scope.row.price,
                                            expression: "scope.row.price"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "100%",
                                          "text-align": "center",
                                          "font-size": "14px",
                                          border: "0"
                                        },
                                        style: {
                                          color:
                                            Number(scope.row.price) ==
                                            Number(scope.row.market_price)
                                              ? "#606266"
                                              : "#FF4040"
                                        },
                                        attrs: { type: "text" },
                                        domProps: { value: scope.row.price },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              scope.row,
                                              "price",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3257632333
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "sum_price",
                              label: "小计"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            (
                                              scope.row.num * scope.row.price
                                            ).toFixed(2)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3791570301
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { align: "center", label: "操作" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("div", [
                                        _c("img", {
                                          staticStyle: {
                                            "margin-left": "-10px",
                                            width: "40px",
                                            height: "40px"
                                          },
                                          attrs: {
                                            src:
                                              _vm.origin +
                                              "/201804/13/15236013235ad04fab6c278.png"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addGoods(scope.row)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("img", {
                                          staticStyle: {
                                            "margin-left": "10px",
                                            "margin-bottom": "5px",
                                            width: "30px",
                                            height: "30px"
                                          },
                                          attrs: {
                                            src:
                                              _vm.origin +
                                              "/201804/13/15236017165ad05134347d8.png"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.delGoods(scope.row)
                                            }
                                          }
                                        })
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3069872638
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-row", [
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "right",
                  height: "40px",
                  background: "rgba(177, 177, 177, 23%)",
                  "line-height": "40px",
                  padding: "0 40px",
                  "font-size": "14px",
                  color: "#ff4040"
                }
              },
              [
                _vm._v(
                  "\n        合计数量：" +
                    _vm._s(_vm.figureNum) +
                    "件 合计金额： ¥" +
                    _vm._s(_vm.figureAllAmount) +
                    "\n      "
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", [
        _c(
          "div",
          [
            _c("div", { staticStyle: { "margin-top": "20px" } }, [
              _c("div", { staticClass: "card-title" }, [_vm._v("金额信息")])
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { border: "", data: _vm.tableFigure }
              },
              [
                _c("el-table-column", {
                  attrs: { label: "代采金额", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        return [
                          _c("div", [_vm._v(_vm._s(_vm.figureAllAmount))])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "实付金额", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        return [
                          _c("div", [_vm._v(_vm._s(_vm.figureRealAmount))])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticStyle: { "padding-bottom": "300px" } },
          [
            _c("div", { staticClass: "card-title" }, [_vm._v("代采备注")]),
            _vm._v(" "),
            _c("el-input", {
              attrs: {
                type: "textarea",
                rows: 8,
                placeholder: _vm.note || "请输入内容"
              },
              model: {
                value: _vm.note,
                callback: function($$v) {
                  _vm.note = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "note"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "right", "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.submit }
                  },
                  [_vm._v("\n          提交")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "danger" },
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("\n          取消")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.dialogTableVisible
        ? _c(
            "div",
            [
              _c(
                "el-dialog",
                {
                  staticStyle: { "margin-top": "-6vh" },
                  attrs: {
                    选择产品: "",
                    visible: _vm.dialogTableVisible,
                    width: "80%"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogTableVisible = $event
                    },
                    open: _vm.handleOpen,
                    close: _vm.handleClose
                  }
                },
                [
                  _c("SelectGoods", {
                    ref: "child",
                    attrs: { supply_id: _vm.supply_id },
                    on: {
                      verifyAddSelectGoods: _vm.addSelectGoods,
                      digclose: _vm.digclose
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73d9f5fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d9f5fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseOrderEdit.vue
// module id = null
// module chunks = 